import { useEffect, useLayoutEffect } from 'react';
import { useTheme } from '../contexts/ThemeContext';

/**
 * Hook to apply theme changes to the document
 * Uses useLayoutEffect for synchronous application to prevent flash
 */
export const useThemeEffect = () => {
  const { currentTheme, getThemeColors, systemTheme } = useTheme();

  // Apply theme synchronously before browser paint to prevent flash
  useLayoutEffect(() => {
    const root = document.documentElement;
    const colors = getThemeColors();

    // Set theme attribute for CSS selectors
    const themeToApply = currentTheme === 'system' ? systemTheme : currentTheme;
    root.setAttribute('data-theme', themeToApply);

    // Apply custom CSS variables for custom theme
    if (currentTheme === 'custom') {
      Object.entries(colors).forEach(([key, value]) => {
        root.style.setProperty(`--custom-${key}`, value);
      });
    } else {
      // Remove custom variables for non-custom themes
      Object.keys(colors).forEach((key) => {
        root.style.removeProperty(`--custom-${key}`);
      });
    }

    // Update meta theme-color for mobile browsers
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      metaThemeColor.setAttribute('content', colors.primary);
    } else {
      const meta = document.createElement('meta');
      meta.name = 'theme-color';
      meta.content = colors.primary;
      document.head.appendChild(meta);
    }

  }, [currentTheme, getThemeColors, systemTheme]);
};

export default useThemeEffect;

